import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import styled, { css } from 'styled-components';
import Image from '@nubank/nuds-web/components/Image/Image';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Grid from '@nubank/nuds-web/components/Grid/Grid';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

const StyledRowContainer = styled.div`
  align-items: center;
  background-color: #f8f8fa;
  border-radius: 12px;
  display: inline-flex;
  gap: 20px;
  justify-content: left;
  position: relative;
  width: 100%;
  margin-top: 15px;

  ${breakpointsMedia({
    xs: css`
      padding: 30px;
    `,
    md: css`
      padding: 30px 80px;
    `,
    lg: css`
      padding: 30px;
    `,
  })}
`;

const StyledIconAndTitleContainer = styled.div`
  position: relative;
  background-color: #f8f8fa;
  border-radius: 12px;
  padding-left: 31px;
  padding-right: 31px;
  padding-bottom: 40px;

  h3 {
    ${breakpointsMedia({
    xs: css`
      font-size: 27px;
    `,
    md: css`
      font-size: 28px;
    `,
    lg: css`
      font-size: 26px;
    `,
    xl: css`
      font-size: 30px;
    `,
  })}
  }

  span {
    /* stylelint-disable property-no-vendor-prefix, property-no-unknown */
    background-image: linear-gradient(137.07deg, #9F2DEB 42.83%, #6200A3 86.85%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
`;

const StyledCardBackgroundImagesContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 17px;
  justify-content: center;
  max-width: 1391px;
  margin: 0 auto;
`;

const StyledTitleIcon = styled(Image)`
  position: absolute;
  margin-top: -50px;

  ${breakpointsMedia({
    md: css`
      left: 12%;
    `,
    lg: css`
      left: 17%;
      margin-top: -80px;
    `,
  })}
`;

const StyledListContainer = styled(Box)`
  ${breakpointsMedia({
    lg: css`
      gap: 20px;
    `,
  })}
`;

function Fees() {
  return (
    <Box
      tag="section"
      height="100%"
      width="100%"
      marginBottom={{ xs: '16x', lg: '100px' }}
      paddingHorizontal={{ xs: '0', lg: '56px' }}
    >
      <Grid
        paddingLeft={{ xs: '0', lg: '0' }}
        paddingRight={{ xs: '0', lg: '0' }}
      >

        {/* CONTENT BOX */}

        <Grid.Child
          gridColumn={{ xs: '1 / span 4', md: '2 / span 4', lg: '2 / span 10' }}
          gridRow="1"
        >
          {/* CARD BACKGROUND IMAGES */}

          <StyledCardBackgroundImagesContainer>
            <Image
              alt="Nubank"
              srcSet={{
                xs: 'credit-card/fees/fees-left.jpg',
                md: 'credit-card/fees/card-background-left-lg.jpg',
              }}
              loading="lazy"
            />
            <Image
              alt="Nubank"
              srcSet={{
                xs: 'credit-card/fees/fees-right.jpg',
                md: 'credit-card/fees/card-background-right-lg.jpg',
              }}
              loading="lazy"
            />
          </StyledCardBackgroundImagesContainer>

          {/* CONTENT ROWS */}

          <Box
            position="relative"
            marginTop={{ xs: '-70px', md: '-20px', lg: '-50px' }}
            maxWidth={{ xs: '100%', lg: '1215px' }}
            paddingHorizontal={{ xs: '32px', lg: '12x' }}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            margin="0 auto"
          >
            <StyledIconAndTitleContainer>
              <StyledTitleIcon
                webp={false}
                alt="Nu"
                src="credit-card/fees/fees-title.svg"
                width={{ xs: '100px', md: '80px', lg: '100px' }}
              />
              <Typography
                strong
                variant="heading3"
                height="100%"
                paddingTop={{ xs: '70px', md: '50px', lg: '40px' }}
                paddingHorizontal={{ xs: '0', md: '12x', lg: '8x' }}
                whiteSpace={{ xs: 'pre-line', lg: 'initial' }}
                textAlign={{ xs: 'left', lg: 'center' }}
              >
                Nu
                <span> te libera </span>
                de estas comisiones:
              </Typography>
            </StyledIconAndTitleContainer>

            <StyledListContainer
              display="flex"
              flexDirection={{ xs: 'column', lg: 'row' }}
              marginTop={{ xs: '0', lg: '24px' }}
            >
              <StyledRowContainer>
                <Image
                  alt="Sin anualidad"
                  src="credit-card/fees/cross-circle.svg"
                  webp={false}
                  width="49px"
                  maxWidth="49px"
                />
                <Typography strong variant="subtitle1" tag="span">
                  Sin Anualidad
                </Typography>
              </StyledRowContainer>

              <StyledRowContainer>
                <Image
                  alt="Sin penalizaciones por uso mínimo"
                  src="credit-card/fees/penal-circle.svg"
                  webp={false}
                  width="49px"
                  maxWidth="49px"
                />
                <Typography strong variant="subtitle1" tag="span" whiteSpace={{ xs: 'normal', lg: 'pre-line' }}>
                  {'Sin penalizaciones \n por uso mínimo'}
                </Typography>
              </StyledRowContainer>

              <StyledRowContainer>
                <Image
                  alt="Sin cobros por reposición si pierdes o roban tu Nu"
                  src="credit-card/fees/card-circle.svg"
                  webp={false}
                  width="49px"
                  maxWidth="49px"
                />
                <Typography variant="subtitle1" tag="span" strong whiteSpace={{ xs: 'normal', lg: 'pre-line' }}>
                  {'Sin cobros por \n reposición si pierdes \n o roban tu Nu'}
                </Typography>
              </StyledRowContainer>
            </StyledListContainer>

          </Box>

        </Grid.Child>

      </Grid>
    </Box>
  );
}

export default Fees;
